// apps/client/src/world/objects/building.ts — civic buildings (shop, museum, well, windmill, market, café): kit models, merged into the static batch
import type { ObjectView } from '../objectView';

export const view: ObjectView = {
  kinds: ['building'],
  async build(obj, ctx) {
    const o = await ctx.assets.model(obj.catalogId);
    o.userData.static = true;
    return o;
  },
};
